import React, { useState, useEffect, useCallback, useRef } from "react";
import VehicleRecommendation from "../components/recommendation/VehicleRecommendation";
import VehicleRecommendationV2 from "../components/recommendation/VehicleRecommendationV2";
import VDPModalContainer from "../components/vdp/VDPModalContainer";

import { FinanceCalculatorProvider } from "../components/modal/financing/storage/CalculatorContext";

export default function SearchRecommended({ props }) {
  const searchdata = typeof props !== 'undefined' ? props : {
    siteSettings: { theme: { colors: {} }, dealers: { dealerRef: [] }, inlineOffers: { slideList: [], freq: 3 } },
    StateResults: [],
    setFavoriteItems: () => { },
    favoriteItem: () => { },
    msrpClass: () => { },
    formatPrice: () => { },
    sortTheItems: () => { },
    lead_url: "",
    site_id: "",
    disclaimerCalculator: "",
    disclaimerContact: "",
    disclaimerFinanceApp: "",
    rates: [1, 2, 3, 4, 5, 6, 7],
    downpayment: 15,
    defaultMonth: 72,
    useCompactCards: false,
    overwriteCTAs: false,
  };

  const { rates, downpayment, defaultMonth } = searchdata;
  const { disclaimerCalculator, disclaimerContact, disclaimerFinanceApp, dealerPhoneDiction } = searchdata;
  const { lead_url, site_id, gtmId } = searchdata;
  const { filterState, overwriteCTAs, staticBtns, staticSrpInlineOffers } = searchdata;
  const { inlineOffers } = searchdata.siteSettings;

  const localStorage = typeof window !== 'undefined' && window.localStorage;
  const { StateResults } = searchdata;
  const { theSlug, formatPrice, sortTheItems } = searchdata;
  const { SRPCardBtns } = searchdata;
  const [hasMounted, setHasMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [StateFavorites, setFavorites] = useState(getFavorites());
  const useCompactCards = searchdata.useCompactCards || false;

  function appendSlash(slug) {
    const lastChar = slug.charAt(slug.length - 1);
    return lastChar === '/' ? slug : slug + '/';
  }

  function getFavorites() {
    let favs = getStorageItem("favoriteItem" + site_id);
    return favs === null ? [] : JSON.parse(favs);
  }

  function getStorageItem(item) {
    return typeof localStorage.getItem !== 'undefined' ? localStorage.getItem(item) : "[]";
  }

  function setStorageItem(item, value) {
    if (typeof localStorage.setItem !== 'undefined') {
      localStorage.setItem(item, value);
    } else {
      console.log('no localStorage');
    }
  }

  function isFavorite(vin) {
    return StateFavorites.findIndex((v) => v === vin) !== -1;
  }

  function favoriteItem(vin) {
    let favs = getStorageItem("favoriteItem" + site_id);
    let theFavs = favs === null ? [] : JSON.parse(favs);
    theFavs = theFavs.filter((value, index, self) => self.indexOf(value) === index);
    if (!theFavs.includes(vin)) {
      theFavs.push(vin);
    } else {
      theFavs.splice(theFavs.indexOf(vin), 1);
    }
    setStorageItem("favoriteItem" + site_id, JSON.stringify(theFavs));
    setFavorites(theFavs);
    props.setFavorites(theFavs);
  }

  function checkDates(list) {
    const today = new Date().getTime();
    let currentOffers = [];
    //console.log('input list:', list)
    if (list) {
      //console.log('runs list')
      list.forEach((slide) => {
        const expiration = slide.expiration ? new Date(slide.expiration) : new Date("01/01/1900");
        const startDate = slide.startDate ? new Date(slide.startDate) : new Date();

        startDate.setHours(0, 0, 0, 0);
        expiration.setHours(23, 59, 59, 59);

        if (startDate.getTime() <= today && today < expiration.getTime()) {
          currentOffers.push(slide);
        } else {
          //console.log('date check was failing')
           currentOffers.push(slide)
          }
      });
    }
   // console.log('output list:', currentOffers)
    return currentOffers;
  }

  function generateOfferCards(adList) {
    if (adList.length > 0) {
      return adList.map((result, index) => {
        return result.htmlAd === '' ? (
          <li className={`srp-offer-card sr-item ${useCompactCards ? "v2" : ""}`} key={index}>
            <a href={result.imageLink || ''}>
              <img className="srp-offer-card-image" src={result.imageSrc} alt="Offer" />
            </a>
          </li>
        ) : (
          <li
            className={`srp-offer-card sr-item ${useCompactCards ? "v2" : ""}`}
            dangerouslySetInnerHTML={{ __html: result.htmlAd }}
            key={index}
          ></li>
        );
      });
    }
  }

  function addInlineOffers(offersList, inventoryList, offerFreq) {
    let newList = [];
    const totalLength = (offersList?.length || 0) + inventoryList.length;
    let offerCounter = 0;
    let inventoryCounter = 0;
    let freqCounter = 0;

    for (let i = 0; i < totalLength; i++) {
      //console.log({i})
      //console.log({ offerCounter, freqCounter, offerFreq, inventoryCounter})
      //console.log({ totalLength, invLength: inventoryList.length, offerLen: offersList.length})
      if (offerCounter >= (offersList?.length || 0)) {
        newList.push(inventoryList[inventoryCounter]);
        inventoryCounter++;
      } else {
        if (freqCounter == offerFreq && i !== 0) {
          //console.log('pushed at some point')
          newList.push(offersList[offerCounter]);
          offerCounter++;
          freqCounter = 0;
        } else {
          if (inventoryCounter < inventoryList.length) {
            newList.push(inventoryList[inventoryCounter]);
            inventoryCounter++;
            freqCounter++;
          }
        }
      }
    }

    //console.log('addInlineOffers output:', newList)
    return newList;
  }

  const observer = useRef();
  const lastItem = useCallback((node) => {
    if (typeof window !== 'undefined') {
      setTimeout(window.dispatchEvent(new Event('DealerMasterEvent')), 1000);
    }
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setPage((prevPage) => prevPage + 1);
      }
    });
    if (node) observer.current.observe(node);
  }, []);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  //console.log('inlineOffers.slideList')
  //console.log(inlineOffers.slideList)
  return (
    <>
      <FinanceCalculatorProvider>
        <VDPModalContainer
          siteData={{
            lead_url,
            site_id,
            gtmId,
            disclaimerContact,
            disclaimerFinanceApp,
            disclaimerCalculator,
            dealers: searchdata.siteSettings.dealers,
          }}
          financeData={{ rates, downpayment, defaultMonth }}
        />
        <section className="sr-container">
          <div className="srp-loader srp-loader-center srp-loading-show"></div>
          <ul className="sr">
            {
              addInlineOffers(
                generateOfferCards(checkDates(inlineOffers.slideList)),
                StateResults.hits.slice(0, Math.min(6 * page, StateResults.total)).map((result, index) => {
                  let item = result;
                  let cnt = (6 * page) - 3;
                  return (
                    <li
                      ref={index === cnt ? lastItem : null}
                      className={`sr-item sr-item_page_${Math.ceil((index + 1) / 10)}`}
                      key={index}
                    >
                      {useCompactCards ? (
                        <VehicleRecommendationV2
                          fallbackText={props.fallbackText}
                          isFavorite={isFavorite(item.VehicleInfo.VIN)}
                          favorite={favoriteItem}
                          theSlug={appendSlash(theSlug)}
                          item={item}
                          unavailableImg={props.unavailableImg}
                          SRPCardBtns={SRPCardBtns}
                          formatPrice={formatPrice}
                          phoneNumber={dealerPhoneDiction[item.VehicleInfo.DealerID]}
                          overwriteCTAs={overwriteCTAs}
                          staticBtns={staticBtns}
                        />
                      ) : (
                        <VehicleRecommendation
                          fallbackText={props.fallbackText}
                          isFavorite={isFavorite(item.VehicleInfo.VIN)}
                          favorite={favoriteItem}
                          theSlug={appendSlash(theSlug)}
                          item={item}
                          unavailableImg={props.unavailableImg}
                          SRPCardBtns={SRPCardBtns}
                          formatPrice={formatPrice}
                          phoneNumber={dealerPhoneDiction[item.VehicleInfo.DealerID]}
                          overwriteCTAs={overwriteCTAs}
                          staticBtns={staticBtns}
                        />
                      )}
                    </li>
                  );
                }),
                inlineOffers.freq
              )
            }
          </ul>
        </section>
      </FinanceCalculatorProvider>
    </>
  );
}
